import { css } from '@emotion/react'

export const baseStyles =
  ({ theme, width, height, rounded, center }) => css`
    width: ${width};
    height: ${height};

    animation: d 1.5s linear infinite forwards;
    background: ${theme.colors.n100};
    background-image: linear-gradient(90deg, ${theme.colors.n100} 0, #f8f8f8 20%, ${theme.colors.n100} 40%, ${theme.colors.n100});
    background-repeat: no-repeat;
    ${center ? css`margin: 0 auto;` : ''};
    ${rounded ? css`border-radius: 50px;` : css`border-radius: 4px;`};
  `
